/**
 * Поля заявления, которые не показываем в форме (по label/name с API).
 * См. mobile: src/utils/applicationFieldFilters.ts
 */
export function normalizeFieldLabel(name) {
    return (name || '').trim().toLowerCase().replace(/\s+/g, ' ');
}

/**
 * @param {{ label?: string|null, name?: string }} field
 */
export function isExcludedApplicationField(field) {
    const label = normalizeFieldLabel(field.label || field.name || '');
    if (!label) return false;
    // «Адрес прописки»
    if (label.includes('адрес') && label.includes('прописк')) {
        return true;
    }
    // «Контактный телефон», «Контактные телефоны», опечатки «контакный»
    if (
        (label.includes('контакт') || label.includes('контак')) &&
        label.includes('телефон')
    ) {
        return true;
    }
    return false;
}

export function filterBlockFields(block) {
    if (!block?.active_fields) return block;
    return {
        ...block,
        active_fields: block.active_fields.filter((f) => !isExcludedApplicationField(f)),
    };
}

/** @param {Array|undefined|null} blocks */
export function filterApplicationFieldBlocks(blocks) {
    if (blocks == null) return blocks;
    if (!Array.isArray(blocks) || blocks.length === 0) return blocks;
    return blocks
        .map(filterBlockFields)
        .filter((b) => (b.active_fields?.length || 0) > 0);
}

/** ID полей, исключённых из UI (по исходным блокам API) — не отправлять в FormData */
export function getExcludedApplicationFieldIds(blocks) {
    const ids = new Set();
    (blocks || []).forEach((block) => {
        (block?.active_fields || []).forEach((f) => {
            if (f?.id != null && isExcludedApplicationField(f)) {
                ids.add(String(f.id));
            }
        });
    });
    return ids;
}
